// Generated from SVG to Code Figma Plugin

export const ErrorIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.25 10C19.25 15.1086 15.1086 19.25 10 19.25C4.89136 19.25 0.75 15.1086 0.75 10C0.75 4.89136 4.89136 0.75 10 0.75C15.1086 0.75 19.25 4.89136 19.25 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.8284 7.1716L7.17151 12.8285"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7.17163 7.1716L12.8285 12.8285"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
